import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const marketingAgentCalendarAccess: DomainAccessControlConfig = {
  permissions: [Permission.MarketingAgentViewAccess],
}

// Union of router (MarketingAgentViewAccess) and domainDef (RetailerFundedMarketingAdminAccess) permissions
export const marketingAgentCalendarUnionAccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.MarketingAgentViewAccess,
    Permission.RetailerFundedMarketingRetailerFundedMarketingAdminAccess,
  ],
}
